import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import Quantity from './quantity'
import { Nullable } from '../../types/common'

class QuantityBtn extends BaseComponent {
  quantity: Nullable<Quantity>

  constructor() {
    super()

    this.quantity = this.closest<Quantity>('quantity-component')
  }

  connectedCallback(): void {
    this.addEventListener('click', this.handleButtonClick)
    this.addEventListener('keydown', this.handleKeyDown)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleButtonClick)
    this.removeEventListener('keydown', this.handleKeyDown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()

    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)
    const target = event.target as HTMLElement

    if (isEnterKey && !target.hasAttribute('disabled')) {
      event.preventDefault()

      this.update()
    }
  }

  update(): void {
    const action = this.dataset.action

    if (this.quantity && action) {
      this.quantity.inputChange(action)

      if (action === 'minus') {
        this.setDisabled()
      }
    }
  }

  setDisabled(): void {
    if (this.quantity && this.quantity.input) {
      const isDisabled = this.quantity.input.value === '1'

      this.toggleAttribute('disabled', isDisabled)
    }
  }
}

export default QuantityBtn
